module.exports = "/assets/1223f807173bfb1b67db70e4235e14ef.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/6E.png
// module id = 2212
// module chunks = 0